<template>
    <b-modal v-model="visible" title="Attribution du médecin" centered size="lg"
        :hide-header-close="saving" :no-close-on-esc="saving" :no-close-on-backdrop="saving"
        @hide="beforeHide" @hidden="onHidden">
        <div class="med-attribution-config">
            <h3 class="c-title">{{ prestation.nom }}</h3>
            <p v-if="loading" role="status">Chargement du réglage…</p>
            <div v-if="error" role="alert" class="text-danger mb-3">
                {{ error }}
                <button v-if="!loaded" type="button" class="btn btn-secondary-light-o mt-2" :disabled="loading" @click="load">Réessayer</button>
            </div>
            <div v-if="loaded">
                <label for="med-auto-policy">Proposition automatique du médecin</label>
                <select id="med-auto-policy" v-model="choice" class="input-secondary-light" :disabled="saving">
                    <option :value="null">Par défaut (activée)</option>
                    <option :value="true">Activée</option>
                    <option :value="false">Désactivée</option>
                </select>
                <p class="small text-grey mt-2">Par défaut : activée pour toutes les spécialités. Vous pouvez la désactiver pour cette prestation.</p>
                <p class="text-primary" role="status">Proposition automatique {{ effective ? 'activée' : 'désactivée' }} pour cette prestation.</p>
                <p class="mb-0">Le choix manuel reste prioritaire. Lorsque cette option est activée et qu’aucun médecin n’est choisi, la proposition doit être confirmée avant de continuer. La présence des médecins n’est pas prise en compte.</p>
            </div>
        </div>
        <template #modal-footer>
            <button type="button" class="btn btn-secondary-light-o btn-radius" :disabled="saving" @click="cancel">Annuler</button>
            <button type="button" class="btn btn-primary btn-radius" :disabled="!loaded || loading || saving" @click="save">{{ saving ? 'Enregistrement…' : 'Enregistrer' }}</button>
        </template>
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import config from '@/store/mods/parametres/config'

function errorMessage(error) {
    const data = error && error.response && error.response.data
    return data && data.message ? data.message : 'Impossible de joindre le service. Réessayez.'
}

export default {
    name: 'attribution-automatique-consultation',
    components: { BModal },
    data() {
        return { visible: false, prestation: {}, choice: null, loaded: false, loading: false, saving: false, error: '', requestId: 0 }
    },
    computed: {
        effective() {
            return this.choice === null ? true : this.choice
        }
    },
    beforeDestroy() { this.requestId++ },
    methods: {
        open(prestation) {
            if (this.saving || !prestation || !Number.isInteger(Number(prestation.id)) || Number(prestation.id) <= 0) return
            this.prestation = { id: Number(prestation.id), nom: prestation.nom, categorie_id: prestation.categorie_id }
            this.choice = null
            this.loaded = false
            this.error = ''
            this.visible = true
            return this.load()
        },
        async load() {
            if (!this.visible || this.saving) return
            const request = ++this.requestId
            const id = this.prestation.id
            this.loading = true
            this.loaded = false
            this.error = ''
            try {
                const result = await config.getAttributionAutomatiqueConsultation(id)
                if (request !== this.requestId || !this.visible) return
                if (!result || ![null, true, false].includes(result.attribution_automatique) || typeof result.auto_attribution !== 'boolean') {
                    throw new Error('Invalid response')
                }
                this.choice = result.attribution_automatique
                this.loaded = true
            } catch (error) {
                if (request === this.requestId && this.visible) this.error = errorMessage(error)
            } finally { if (request === this.requestId) this.loading = false }
        },
        cancel() {
            if (this.saving) return
            this.requestId++
            this.visible = false
            this.loaded = false
            this.loading = false
        },
        beforeHide(event) {
            if (this.saving) event.preventDefault()
            else this.requestId++
        },
        onHidden() {
            if (this.visible) return
            this.requestId++
            this.loaded = false
            this.loading = false
            this.error = ''
        },
        async save() {
            if (!this.visible || !this.loaded || this.loading || this.saving || ![null, true, false].includes(this.choice)) return
            const request = ++this.requestId
            const id = this.prestation.id
            this.saving = true
            this.error = ''
            try {
                const result = await config.saveAttributionAutomatiqueConsultation(id, { attribution_automatique: this.choice })
                if (request !== this.requestId || this._isDestroyed) return
                this.$emit('saved', { id, configuration: result })
                this.saving = false
                this.visible = false
                this.loaded = false
            } catch (error) {
                if (request === this.requestId && !this._isDestroyed) this.error = errorMessage(error)
            } finally { if (request === this.requestId) this.saving = false }
        }
    }
}
</script>

<style scoped lang="scss">
.med-attribution-config { padding: 12px; }
</style>
